import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'
import { getToken } from '@/utils/request'

// const CancelToken = axios.CancelToken
// const isProd = process.env.NODE_ENV === 'production'
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url/
  // baseURL: 'http://192.168.38.69:6001',
  // baseURL: 'http://172.15.16.142:6001', // url = base url + request url
  // baseURL: 'http://172.17.1.175:6001',
  // baseURL: 'http://scrm-act-test.dflzm.com',
  // baseURL: 'http://172.21.152.126:7005',
  baseURL: '',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout 50s
})

// let setTimeoutFun = true

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // Cookies.set('_ac','zhangdx')
      // const getToken = () => 'f1fa9360-970c-461c-a523-fe9293800377'
      // if (getToken()) {
      //   config.headers['X-token'] = getToken()
      // } else {
      //   config.headers['X-token'] = ''
      // }
    }
    // config.headers['token'] = '53ov51cjo4k10qg7chrl3cr2c4vnbtbfjio00001id67q25s'   //  7odj5m2mojad586tjg3motgd2k363tjobb3g0001id6ocd60
    config.headers['token'] = getToken()
    // 批量取消请求存储
    // config.cancelToken = new CancelToken((cancel) => {
    //   store.dispatch('requests/AddRequests', cancel)
    // })
    // if (setTimeoutFun) {
    //   setTimeout(() => {
    //     store.dispatch('requests/ClearRequests')
    //     setTimeoutFun = true
    //   }, 1000 * 60 * 5)
    // }
    // setTimeoutFun = false

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log(res)
    // if the custom code is not 1, it is judged as an error.
    // res.code == undefined 响应为流文件
    // res.type == 'application/json' blob文件获取失败 但是失败信息被转换为blob类型
    if (res.type === 'application/json') {
      Message({
        message: '请求取消或内容为空！！',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    }
    if ((res.code !== 0 && res.code !== 1 && res.code !== 2 && res.code !== undefined)) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      if (res.code === 500) {
        if (res.msg) {
          let verrifyUrl = 'https://lqdm-scrm-dev.dflzm.com/iam/oauth/authorize?client_id=89343835&redirect_uri=http://localhost:6001CUSTOMER-SERVE/sso/authorize&response_type=code&state=123&nonce=456&appid=1521656042879318'

          if (process.env.NODE_ENV === 'staging') {
            verrifyUrl = 'https://lqdm-scrm-dev.dflzm.com/iam/oauth/authorize?client_id=85767516&redirect_uri=http://scrm-act-test.dflzm.comCUSTOMER-SERVE/sso/authorize&response_type=code&state=123&nonce=456&appid=1521656042879318'
          }
          if (process.env.NODE_ENV === 'production') {
            verrifyUrl = 'https://go.dflzm.com/iam/oauth/authorize?client_id=86640067&redirect_uri=http://scrm-act.dflzm.comCUSTOMER-SERVE/sso/authorize&response_type=code&state=123&nonce=456&appid=8431667700594120'
          }
          // const resMsg = res.msg.split('已过期')[0]
          if (res.msg.indexOf('Token已过期') !== -1 || res.msg.indexOf('Token无效') !== -1) {
            MessageBox.confirm('登录信息过期', '提示信息', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // console.log(verrifyUrl)
              store.dispatch('user/resetToken').then(() => {
                window.location.replace(verrifyUrl)
              })
            })
          }
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 转换方法
// const blobToObj = (data) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader()
//     reader.readAsText(data, 'utf-8')
//     reader.onload = function() {
//       try {
//         resolve(JSON.parse(reader.result))
//       } catch (error) {
//         resolve({
//           code: 200,
//           message: '获取文件信息成功'
//         })
//       }
//     }
//   })
// }

export default service
